import "./styles/App.css";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import NavBar from "./components/tabs/tab-component";
import ErrorPage from "./Pages/Err";
import Main from "./Pages/Main";
import ChestPage from "./Pages/Chests";
import Home from "./Pages/Home";
import Mining from "./Pages/Mining";

function App() {
  return (
    <BrowserRouter>
      {/* <Snowfall snowflakeCount={35} speed={[0.1, 0.3]} wind={[-1, 1.5]} /> */}
      <div className="app-container">
        <Routes>
          <Route path="/" element={<Main />} />
          <Route path="/home" element={<Home />} />
          <Route path="/mining" element={<Mining />} />
          <Route path="/daily-bonus" element={<ChestPage />} />
          <Route path="*" element={<ErrorPage />} />
        </Routes>
      </div>
        <NavBar />
    </BrowserRouter>
  );
}

export default App;
